import { connect } from 'react-redux';

import { CommercialAboutBuilding, ICommercialAboutBuildingProps } from './index';
import { IState } from '../../../store';

function mapStateToProps(state: IState): ICommercialAboutBuildingProps {
  return {
    building: state.offerData.offer.building,
    businessShoppingCenter: state.offerData.businessShoppingCenter,
    offer: state.offerData.offer,
  };
}

export const CommercialAboutBuildingContainer = connect<ICommercialAboutBuildingProps, {}, {}>(mapStateToProps)(
  CommercialAboutBuilding,
);
